<template>
  <!-- Card Request Modal Structure -->
  <div id="card_response" class="modal services">
    <div class="modal-header">
      <a class="modal-close waves-effect btn-small waves-green right">x</a>
      <!-- <img src="ui/img/logo.png" width="18%" class="responsive-img"> -->
    </div>
    <div class="modal-content">
      <h5>Card Permission</h5>
      <p>Would you like to proceed with the card details below?</p>
      <div class="row">
        <div class="card cardText">
          <input
            class="with-gap"
            name="cardOption"
            value="cardDefault"
            v-model="fields.card"
            type="radio"
            :disabled="loading"
            checked
          />
          <span
            ><strong>
              {{
                cardDetails.bank +
                  ' ' +
                  cardDetails.card_type +
                  ' ending with ' +
                  cardDetails.last4
              }}
            </strong></span
          >
          <!-- <span><strong> Access Bank Visa card ending with 1234</strong></span> -->
        </div>
      </div>
      <div class="row">
        <div
          class="input-field col s12 m12"
        >
          <i
            class="material-icons prefix"
            @click="visibility = !visibility"
            style="cursor: pointer;"
            >{{ visibility ? 'visibility_off' : 'visibility_on' }}</i
          >
          <input id="passwordCard" :type="visibility ? 'text' : 'password'" v-model="password" />
          <label for="passwordCard" class="active">Confirm Password</label>
        </div>
      </div>
      <div v-if="loading">
        <img src="ui/img/loading.svg" alt="Time Loader" />
        <p><i>Loading...</i></p>
      </div>
      <div class="row right" v-else>
        <button
          id="changeCard"
          class="btn-small waves-effect green darken-2 waves-dark"
          style="margin-right: 15px"
          @click.prevent="paywithcard"
        >
          Use another Card
        </button>
        <button
          id="continueCard"
          class="btn-small waves-effect green darken-2 waves-dark"
          @click="chargeCard"
        >
          Continue
        </button>
      </div>
    </div>
  </div>
  <!-- Card Request Modal Structure -->
</template>
<script>
export default {
  props: ['cardDetails', 'loading'],
  mounted() {
    // this.initModal()
  },
  data() {
    return {
      modalInstance: {},
      fields: {
        card: 'cardDefault'
      },
      password: '',
      visibility: false
    }
  },
  methods: {
    initModal() {
      // initialize modal for the document
      const option = { dismissible: false, preventScrolling: true }
      var elems = document.querySelectorAll('.modal.services')
      var instances = M.Modal.init(elems, option)
      this.modalInstance = instances
    },
    paywithcard() {
      this.$emit('otherCard')
    },
    chargeCard() {
      if(this.password) {
        this.$emit('chargeCard', this.password)
      } else {
        M.toast({
          html: 'Please provide your password...',
          classes: 'error'
        })
      }
    }
  }
}
</script>
<style scoped>
.modal .modal-content {
  padding: 0px 24px;
}
.modal.services {
  transform: translate(0%, -50%) !important;
  width: 42%;
  top: 50% !important;
}
.card {
  /* Add shadows to create the "card" effect */
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  padding: 20px 0px;
}
/* On mouse-over, add a deeper shadow */
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
@media screen and (max-width: 600px) {
  .modal.services {
    transform: translate(0%, -50%) !important;
    width: 100%;
    top: 50% !important;
  }
}
.alert-warning {
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
}
.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.cardText span {
  font-size: 1rem;
  line-height: 120%;
}
</style>
